"use client";
import { j as l } from "./index.es176.js";
import { useState as h, useEffect as N } from "react";
import { composeClassNames as a } from "./index.es282.js";
import S from "./index.es283.js";
const _ = ({
  type: c = "button",
  children: m,
  styleType: o = "primary",
  isSmall: n = !1,
  isFullWidth: u,
  isLoading: t = !1,
  loadingDelayMs: e = 0,
  onClick: d,
  isDisabled: f = !1,
  iconName: r,
  isIconOnly: b,
  iconSize: p,
  ...y
}) => {
  const [s, i] = h(t), g = t && !s;
  N(() => {
    if (e === 0) {
      i(t);
      return;
    }
    if (t) {
      const x = setTimeout(() => {
        i(!0);
      }, e);
      return () => clearTimeout(x);
    } else
      i(!1);
  }, [t, e]);
  const j = p || "small";
  return /* @__PURE__ */ l.jsxs(
    "button",
    {
      ...y,
      className: a(
        "bl-button",
        n && "bl-button--small",
        !n && "bl-button--medium",
        b && "bl-button--icon-only",
        u && "bl-button--fluid",
        s && "bl-button--loading",
        g && "bl-button--pending-loading",
        o && `bl-button--${o}`
      ),
      onClick: d,
      type: c,
      disabled: f || t,
      children: [
        /* @__PURE__ */ l.jsx(
          "span",
          {
            className: a(
              "bl-button__consumer-content",
              b && "bl-sr-only"
            ),
            children: m
          }
        ),
        r && /* @__PURE__ */ l.jsx(
          "i",
          {
            "aria-hidden": !0,
            className: a(
              `bl-icon--${r}`,
              `bl-icon--${j}`
            )
          }
        ),
        s && /* @__PURE__ */ l.jsx(
          S,
          {
            isDark: o === "secondary" || o === "tertiary",
            isSmall: n
          }
        )
      ]
    }
  );
};
export {
  _ as default
};
//# sourceMappingURL=index.es177.js.map
